export const environment = {
    production: true,
    apiUrl: 'https://api.terracor.ca/',
    name: 'prod'
};
